import * as React from "react"
const SvgResize = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M19.29 16.862a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414-1.414zm-.827-4.828a1 1 0 0 1 1.414 1.415l-7 7a1 1 0 0 1-1.414-1.415z" />
  </svg>
)
export default SvgResize
